<div class="flex flex-column gap-200">
  <div cdkDropList [cdkDropListData]="events.value" (cdkDropListDropped)="isEditing ? drop($event) : null" class="drag-container">
    @for (event of events.value; let i = $index; track event.id) {
      <div cdkDrag class="drag-item">
        <!-- Icono de arrastre -->
        @if (isEditing) {
      <span cdkDragHandle class="drag-handle" [class.no-visible]="isSpecialEvent(event)">
           <app-st-icon [bold]="true" name="drag_indicator"></app-st-icon>
          </span>
        }

        <div>
          <!-- Contenido de cada elemento -->
          <div>
            <p>
              <app-st-icon [color]="event.color" [bold]="true" [name]="event.icon"></app-st-icon> <span class="text-label-14 text-dark text-semibold"> {{ event.name }}</span>
            </p>
            @if (event.name === 'Orden creada') {
              <p class="activator">Activador: <span>Automático</span></p>
            } @else {
              @if (!event.activator?.location && event.activator?.value) {
                <p class="activator">Activador: <span>{{ event.activator?.name }} / {{getValue(event.activator?.value)}}</span></p>
              }
              @if (event.activator?.location) {
                <p class="activator">Activador: <span>Manual / {{event.activator?.location?.name}}</span></p>
              }
              @if (!event.activator?.location && !event.activator?.value) {
                <p class="activator">Activador: <span>Manual</span></p>
              }
            }
            <p class="activator">Estado Mojito360: <span>{{event.activator?.mojitoDynamicField?.label || '-'}}</span></p>
          </div>

          <!-- Botón de editar -->
          @if (isEditing) {
            <button  (click)="openAddOrEditEvent.emit(event.id)" nz-button nzType="text" class="edit-btn"
                    nzShape="circle" [class.no-visible]="isSpecialEvent(event)">
              <app-st-icon [bold]="true" name="edit"></app-st-icon>
            </button>
          }
        </div>

        <!-- Botón de eliminar -->
        @if (isEditing) {
          <button (click)="removeEvent(i)" nz-button nzType="text" class="delete-btn" nzShape="circle"
                  nzDanger [class.no-visible]="isSpecialEvent(event)">
            <app-st-icon [bold]="true" name="delete" class="text-danger" ></app-st-icon>
          </button>
        }
      </div>
    }
  </div>

  <!-- Botón de agregar evento -->
  @if (isEditing) {
    <button (click)="openAddOrEditEvent.emit(null)" class="add-event" nz-button nzType="text" nzShape="round" nzSize="large">
      <app-st-icon class="prefix" [name]="'add'" [bold]="true"></app-st-icon>
      <span>Añadir evento</span>
    </button>
  }
</div>
